<template>
	<div class="document">
		<svgicon name="medical doc" :fill="false" class="icon"/>
		<div class="name">{{ document.name }}</div>
		<div class="data">
			<div class="responsible">
				<span class="label">Responsible</span>
				<span class="value">{{ document.responsible }}</span>
			</div>
			<div class="description">
				<span class="label">Description</span>
				<span class="value">{{ document.description }}</span>
			</div>
		</div>
		<div class="btn-group">
			<span v-if="metadata.error" title="Error">
				<svgicon name="file" :fill="false" class="icon error"/>
			</span>
			<spinner v-else-if="metadata.loading"/>
			<button-icon-loading v-else @click.native="downloadAttachment" icon="download"/>
			<button-icon-loading @click.native="editDocument" icon="edit"/>
			<button-icon-loading @click.native="deleteDocument" icon="trash" class="btn-delete"/>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id',
		'document'
	],
	data () {
		return {
			metadata: {
				loading: false,
				error: null,
				data: null
			},
			delete: {
				loading: false,
				error: null
			}
		}
	},
	methods: {
		getDocumentMetadata () {
			this.metadata.loading = true
			this.$api.files.getMetadata(this, this.user_uid, this.watch_id, this.document.file)
				.then(response => {
					this.$log.info('watch medicaldocuments', 'files.getMetadata OK', response)()
					this.metadata.data = response.body
				}).catch(error => {
					this.$log.error('watch medicaldocuments', 'files.getMetadata ERROR', error)()
					this.metadata.error = error
				}).finally(() => {
					this.metadata.loading = false
				})
		},
		downloadAttachment () {
			this.$api.files.get(this, this.user_uid, this.watch_id, this.document.file)
				.then(response => {
					this.$log.info('watch medicaldocuments', 'files.get OK', response)()
					let arrayBuffer = response.body
					let blob = new Blob([arrayBuffer], { type: 'application/download' })
					let link = document.createElement('a')
					link.href = window.URL.createObjectURL(blob)
					link.download = this.document.name + '.' + this.metadata.data.extension
					link.click()
				}).catch(error => {
					this.$log.error('watch medicaldocuments', 'files.get ERROR', error)()
				})
		},
		editDocument () {
			this.$root.$emit('editDocument', { action: 'edit', id: this.document.id })
		},
		deleteDocument () {
			if (confirm('Delete?')) {
				this.delete.loading = true
				this.$api.medicaldocuments.delete(this, this.user_uid, this.watch_id, this.document.id)
					.then(response => {
						this.$log.info('watch medicaldocuments', 'medicaldocuments.delete OK', response)()
						this.$emit('delete')
					}).catch(error => {
						this.$log.error('watch medicaldocuments', 'medicaldocuments.delete ERROR', error)()
						this.delete.error = error
					}).finally(() => {
						this.delete.loading = false
					})
			}
		}
	},
	created () {
		this.getDocumentMetadata()
	}
}
</script>


// WEBPACK FOOTER //
// src/components/watch/medicaldocuments/MedicalDocument.vue